export const GENDER_TYPES = [
    { text: 'Kadın', code: 1},
    { text: 'Erkek', code: 2},
    { text: 'Belirtmek istemiyorum', code: 3}
]

export const EDUCATION_TYPES = [
    { text: 'Lise öğrencisi', code: 1},
    { text: 'Lise mezunu', code: 2},
    { text: 'Üniversite öğrencisi', code: 3},
    { text: 'Üniversite mezunu', code: 4},
    { text: 'Yüksek Lisans', code: 5},
    { text: 'Doktora', code: 6},
    { text: 'Diğer', code: 7}
]

export const PROFESSION_TYPES = [
    { text: 'Çalışıyor', code: 1},
    { text: 'Çalışmıyor', code: 2},
    { text: 'Öğrenci', code: 3},
    { text: 'Öğrenci - Çalışıyor', code: 4},
    { text: 'Emekli - Çalışıyor', code: 5},
    { text: 'Emekli', code: 6}
]

export const ANNOUNCEMENT_STATUS_TYPES = [
    { text: 'Aktif', code: 1},
    { text: 'Pasif', code: 2}
]

export const EVENT_STATUS_TYPES = [
    { text: 'Aktif', code: 1},
    { text: 'Pasif', code: 2}
]

export const REQUEST_TYPES = [
    { text: 'Destek', code: 1},
    { text: 'Öneri', code: 2},
    { text: 'Şikayet', code: 3}
]

export const APPLICATION_STATUS_TYPES = [
    { text: 'Başvuru yapıldı', code: 1},
    { text: 'Onaylandı', code: 2},
    { text: 'Reddedildi', code: 3},
    { text: 'Tamamlandı', code: 4},
    { text: 'Bekleme listesine alındı', code: 5},
    { text: 'Katılmadı', code: 6},
    { text: 'Başvuru geri çekildi', code: 10}
]

export const USER_APPLICATION_STATUS_TYPES = [
    { text: 'Başvuru yapıldı', code: 1},
    { text: 'Onaylandı', code: 2},
    { text: 'Bekliyor', code: 3},
    { text: 'Tamamlandı', code: 4},
    { text: 'Bekleme listesine alındı', code: 5},
    { text: 'Katılmadı', code: 6},
    { text: 'Başvuru geri çekildi', code: 10}
]

export const APPLICATION_SENT_EMAIL = [
    { text: 'Başvuru alındı', code: 6},
    { text: 'Onay', code: 7},
    { text: 'Ret', code: 8},
    { text: 'Tamamlama', code: 9},
    { text: 'Bekleme listesi', code: 10}
]